import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'emm-class-type-chips',
    templateUrl: './class-type-chips.component.html',
    styleUrls: ['./class-type-chips.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ClassTypeChipsComponent {
    @Input() itemClassLabel = '';
    @Input() itemTypeName?: string | null;
}
